import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloSazonalidade } from "../models/sazonalidade";
import { ModeloSopFinance } from "../models/sopFinance";

import { Repositorio } from "./repositorio";

export class FiltroSopFinance {
  editados = false;
  flg_aberto = false;
  num_nivel = 0;

  dth_inicio?: Date | null;
  dth_fim?: Date | null;

  cod_business_unit?: string;
  cod_region?: string;
  cod_product?: string;
  cod_product_family?: string;
  resale = false;


  cod_linha_produto_capitao?: string;
  cod_familia_subgrupo_produto_capitao?: string;
  cod_gerencia?: string;
  cod_acabamento?: string;
  cod_temperatura?: string;
  cod_mercado?: string;
  cod_tipo_produto?: string;
  cod_produto_capitao?: string;

  value?: string = "Revenue";

  des_valor?: number;
  cod_usuario?: number;
  constructor() {
    const today = new Date();
    this.dth_inicio = new Date(today.getFullYear(), today.getMonth() - 12, 1); // 1 ano atrás
    this.dth_fim = new Date(today.getFullYear(), today.getMonth() + 3, 1);    // 3 meses à frente
  }

}

export class RepositorioSopFinance extends Repositorio<ModeloSopFinance> {
  constructor() {
    super(ConstanteGlobal.SOP_FINANCE);
  }

  atualizarValor(des_atributo: string, des_valor: string, modelo: ModeloSopFinance) {
    return this.api.post(this.nomeRepositorio + "_atualizar_valor", { des_atributo, des_valor, ...modelo }).then((res) => {
      return res.data;
    });
  }

  postSimular(filtro: FiltroSopFinance) {
    return this.api.post(this.nomeRepositorio + "_post_simular", filtro).then((res) => {
      return res.data;
    });
  }

  getPrevisao(filtro: FiltroSopFinance) {
    return this.api.post(this.nomeRepositorio + "_previsao", filtro).then((res) => {
      return res.data;
    });
  }
  getKpis(filtro: FiltroSopFinance) {
    return this.api.post(this.nomeRepositorio + "_kpis", filtro).then((res) => {
      return res.data;
    });
  }

  getQuantity(filtro: FiltroSopFinance) {
    return this.api.post(this.nomeRepositorio + "_quantity", filtro).then((res) => {
      return res.data;
    });
  }
  getShareRegion(filtro: FiltroSopFinance) {
    return this.api.post(this.nomeRepositorio + "_share_region", filtro).then((res) => {
      return res.data;
    });
  }

  soaFinanceLimpaRegistros(filtro: FiltroSopFinance) {
    return this.api.post(this.nomeRepositorio + "_limpa_registros", filtro).then((res) => {
      return res.data;
    });
  }

}
